import { render, staticRenderFns } from "./ESic.vue?vue&type=template&id=97c0137c"
import script from "./ESic.vue?vue&type=script&lang=ts"
export * from "./ESic.vue?vue&type=script&lang=ts"
import style0 from "./ESic.vue?vue&type=style&index=0&id=97c0137c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports